import { render, staticRenderFns } from "./PhotoCardV2.vue?vue&type=template&id=f89ede64"
import script from "./PhotoCardV2.vue?vue&type=script&lang=js"
export * from "./PhotoCardV2.vue?vue&type=script&lang=js"
import style0 from "./PhotoCardV2.vue?vue&type=style&index=0&id=f89ede64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports